const absenceTypeOptions = [
  {label: 'Cough, Cold, Flu', value: 'cough-cold-flu'},
  {label: 'Digestive / Stomach', value: 'digestive-stomach'},
  {label: 'Headache / Migraine', value: 'headache-migraine'},
  {label: 'Non-work Related Injury', value: 'non-work-related-injury'},
  {label: 'Other', value: 'other'},
  {label: 'Psychiatric / Stress', value: 'psychiatric-stress'},
  {label: 'Work Related Injury', value: 'work-related-injury'},
  {label: 'Holiday', value: 'holiday'},
  {label: 'Time off in lieu', value: 'time-off-in-lieu'},
  {label: 'Charity Days', value: 'charity-days'},
  {label: 'Compassionate', value: 'compassionate'},
  {label: 'Jury Service', value: 'jury-service'},
  {label: 'Maternity', value: 'maternity'},
  {label: 'Medical Appointment', value: 'medical-appointment'},
  {label: 'Other', value: 'other'},
  {label: 'Parental', value: 'parental'},
  {label: 'Paternity', value: 'paternity'},
  {label: 'Study', value: 'study'},
  {label: 'Training', value: 'training'},
  {label: 'Unauthorised', value: 'unauthorised'},
  {label: 'Unpaid Leave', value: 'unpaid-leave'},
];

const absenceType = (value) => {
  const type = absenceTypeOptions.filter((t) => t.value === value);

  return type.length > 0 ? type[0].label : null;
};

export {
  absenceTypeOptions,
  absenceType,
};

export default absenceType;
